import InfoIcon from "@mui/icons-material/Info";

export default function WarningLabel(props: { text: string }) {
  return (
    <div className="text-[14px] font-normal text-warning-600 bg-warning-50 p-[12px] rounded-[5px] flex items-center gap-[8px]">
      <InfoIcon color="inherit" />
      {props.text}
    </div>
  );
}
